import { render } from "./ContactForm.vue?vue&type=template&id=454fb744&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import "./ContactForm.vue?vue&type=style&index=0&id=454fb744&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454fb744"]])

export default __exports__